import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import ViewComponent from "../ViewComponent"
import telematicsService from "../../api/telematics.service"; 

export default {
  name: 'view-contract-details',
  components: {pageheader , ViewComponent},
  props: [],
  data () {
    return {
      input:{},
      componentName:"view-contract-details",
      isDetailsLoading:false,
      viewDataById: {},
     

    }
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted () {
    this.input = utils.getInputContent("viewcontracts", this.roles);
   
    this.readDataById();
  },
  methods: {
    async readDataById(){
      this.isDetailsLoading = true;
      try {
        let response = await telematicsService.getcontractsDataById(this.$route.params.id);
        if (response.isSuccess) {
          this.isDetailsLoading = false;
          this.viewDataById = response.data;
        } else{
          this.isDetailsLoading = false;
          this.viewDataById = {};        
        }
      } catch (error) {
        this.isDetailsLoading = false;
        this.$toast.error("Unable to load the data" + error);
      }
    },
  }
}


